<template>
    <div class="grey-bg">
        <top-carousel></top-carousel>
        <div class="body-nav">
            <ul class="ul-nav page-width page-content" id="tabs">
                <li id="14">公司新闻</li>
                <li id="15">行业资讯</li>
            </ul>
        </div>
        <div class="scd_m news page-content">
            <dl class="clearfix" v-for="item in list" :key="item.F_Id">
                <img
                    :src="item.F_Img | toSrc"
                    alt=""
                    @click="jumpPage(item.F_Id)"
                />
                <dd>
                    <div class="title" @click="jumpPage(item.F_Id)">
                        {{ item.F_Title }}
                    </div>
                    <div class="ctn">
                        {{ item.F_Sketch }}
                    </div>
                    <div class="time">
                        <span>{{ item.F_CreatorTime | toDate }}</span>
                        <a @click="jumpPage(item.F_Id)">查看更多</a>
                    </div>
                </dd>
            </dl>

            <div class="pagination" v-if="list && list.length > 0">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next,jumper"
                    :current-page="query.page"
                    :page-size="query.rows"
                    :total="totalcount"
                    @current-change="pageChange"
                    @size-change="sizeChange"
                    :page-sizes="pageSizes"
                ></el-pagination>
            </div>
            <div v-else class="no-data">
                <img src="../../../../assets/img/common/img_empty.png" alt="">
                <div class="empty-txt">暂无数据</div>
            </div>
        </div>
    </div>
</template>

<script>
import { getData } from '../../../../service/secondHttp'
import $ from 'jquery'
export default {
    data() {
        return {
            query: {
                page: 1,
                rows: 10,
                sidx: 'F_CreatorTime',
                sord: 'desc',
                category: '',
            },
            pageSizes: [5, 10, 20],
            totalcount: 0,
            list: [],
            id: this.$route.params.id,
        }
    },
    methods: {
        getData() {
            getData('Article', this)
        },
        pageChange(val) {
            getData('Article', this, val)
        },
        sizeChange(size) {
            this.query.rows = size
            this.getData()
        },
        toggleTab() {
            let that = this
            $('#tabs').on('click', 'li', function () {
                $(this).addClass('active').siblings().removeClass('active')
                that.$router.push('/newsList/' + this.id)
            })
        },
        jumpPage(id) {
            this.$router.push('/newsDetail/' + id + '/' + this.id)
        },
        setCurrentTab() {
            // 公司新闻
            if (this.id == 14) {
                this.query.category = 1
                // 行业资讯
            } else if (this.id == 15) {
                this.query.category = 2
            }
            $('#' + this.id)
                .addClass('active')
                .siblings()
                .removeClass('active')
            this.getData()
        },
    },
    mounted() {
        this.toggleTab()
        this.setCurrentTab()
    },
}
</script>

<style scoped lang="less">
.scd_m {
    padding: 42px 0 0;
}
.news dl {
    margin-bottom: 30px;
    height: 216px;
}
.news dl img {
    width: 32%;
    float: left;
    max-height: 100%;
    cursor: pointer;
}
a {
    color: #0a439e;
}
a:hover {
    color: #0a439e;
}
.news dl dd {
    margin-left: 32%;
    background: #ffffff;
    height: 100%;
    padding: 31px 38px 26px 36px;
}
.news dl dd .title {
    font-weight: bold;
    color: #333333;
    line-height: 24px;
    margin-bottom: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 18px;
    cursor: pointer;
}
.news dl dd .ctn {
    height: 94px;
    line-height: 24px;
    font-size: 14px;
    color: #737373;
    overflow: hidden;
}
.news dl dd .time {
    margin-top: 8px;
    height: 35px;
    line-height: 35px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
}
.news dl dd .time span {
    color: #999999;
}
.pagination {
    width: 100%;
}
/deep/ .el-pagination {
    float: right;
    margin-top: -6px;
    margin-bottom: -6px;
}
.no-data {
    height: 400px;
    display: flex;
    margin-top:-42px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    >img{
        width:120px;
    }
    .empty-txt {
        font-size: 14px;
        color:#999;
    }
}
</style>
